"use client";

import { useEffect } from "react";
import { useOfflineContext } from "@/contexts/offline-context";

export function ServiceWorkerManager() {
  const { isOnline } = useOfflineContext();

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;

    // ponytail: el SW hace networkFirst sobre navegación/RSC y sirve payloads
    // stale -> rompe el App Router ("Router action dispatched before initialization")
    // y pelea con Fast Refresh. En dev lo desregistramos y limpiamos caches.
    if (process.env.NODE_ENV !== "production") {
      navigator.serviceWorker.getRegistrations().then(regs => {
        regs.forEach(reg => reg.unregister());
      });
      if ("caches" in window) {
        caches.keys().then(keys => keys.forEach(k => caches.delete(k)));
      }
      return;
    }

    let registration: ServiceWorkerRegistration | undefined;
    let currentInstallingWorker: ServiceWorker | null = null;

    function handleStateChange() {
      if (
        currentInstallingWorker?.state === "installed" &&
        navigator.serviceWorker.controller
      ) {
        console.log("[App] New SW available");
        // Puedes mostrar un toast aquí para informar al usuario
        // toast.info('Nueva versión disponible. Refresca la página.');
      }
    }

    function handleUpdateFound() {
      if (currentInstallingWorker) {
        currentInstallingWorker.removeEventListener(
          "statechange",
          handleStateChange
        );
      }
      currentInstallingWorker = registration?.installing ?? null;
      if (currentInstallingWorker) {
        currentInstallingWorker.addEventListener(
          "statechange",
          handleStateChange
        );
      }
    }

    navigator.serviceWorker
      .register("/sw.js")
      .then(reg => {
        registration = reg;
        registration.addEventListener("updatefound", handleUpdateFound);
        console.log("[App] SW registered:", registration.scope);
      })
      .catch(err => console.error("[App] SW registration failed:", err));

    // Background Sync Registration (si está disponible)
    navigator.serviceWorker.ready.then(registration => {
      if ("sync" in registration) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (registration as any).sync
          .register("sync-pending-operations")
          .catch((err: Error) => {
            console.warn("[App] Background sync registration failed:", err);
          });
      }
    });

    return () => {
      if (registration) {
        registration.removeEventListener("updatefound", handleUpdateFound);
      }
      if (currentInstallingWorker) {
        currentInstallingWorker.removeEventListener(
          "statechange",
          handleStateChange
        );
      }
    };
  }, []);

  // Prefetch cuando vuelve online
  useEffect(() => {
    if (
      isOnline &&
      "serviceWorker" in navigator &&
      navigator.serviceWorker.controller
    ) {
      // Prefetch rutas importantes cuando recupera conexión
      const criticalRoutes = [
        // "/dashboard",
        // "/dashboard/workshop",
        // "/dashboard/inspection",
        "/dashboard/brands",
      ];

      navigator.serviceWorker.controller.postMessage({
        type: "PREFETCH",
        action: { urls: criticalRoutes },
      });

      console.log("[App] Prefetching critical routes");
    }
  }, [isOnline]);

  return null;
}
